import { HeartHandshake, MessageCircleMore, Clock } from "lucide-react";
import { useState, useEffect } from "react";

const HighSchoolersPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const cards = [
    {
      title: "Volunteering",
      icon: (
        <HeartHandshake className="w-16 h-16 md:w-12 md:h-12 text-white mb-4 fill-current" />
      ),
      description:
        "Connect with local gally's service opportunities and make a difference.",
    },
    {
      title: "Counselling",
      icon: (
        <MessageCircleMore className="w-16 h-16 md:w-12 md:h-12 text-white mb-4 fill-current" />
      ),
      description:
        "Get guidance on academic planning, college preparation, and personal development from experienced local counselors.",
    },
  ];

  return (
    <div className="p-4 font-sans">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2 text-gray-800 font-fraunces">
          High Schoolers
        </h1>
        <p className="text-gray-600 text-lg font-afacad">
          Resources and opportunities to help you grow from your Gally to the
          Globe.
        </p>
      </div>

      {/* Cards Container */}
      <div
        className={`${
          !isMobile ? "grid grid-cols-1 md:grid-cols-2 gap-8" : "space-y-6"
        }`}
      >
        {cards.map((card, index) => (
          <div
            key={index}
            className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            style={{ backgroundColor: "#7B189F" }}
          >
            {/* Coming Soon Badge */}
            <div className="absolute top-4 right-4 bg-white bg-opacity-20 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2">
              <Clock className="w-4 h-4 text-white fill-current" />
              <span className="text-white text-sm font-medium font-afacad">
                Coming Soon
              </span>
            </div>

            {/* Card Content */}
            <div
              className={`p-8 ${
                isMobile ? "h-72" : "h-64"
              } flex flex-col justify-center items-center text-center`}
            >
              {card.icon}

              <h2 className="text-2xl font-bold text-white mb-4 font-fraunces">
                {card.title}
              </h2>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-10 -right-10 w-20 h-20 bg-white bg-opacity-10 rounded-full"></div>
            <div className="absolute -bottom-6 -left-6 w-16 h-16 bg-white bg-opacity-10 rounded-full"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HighSchoolersPage;
